module.exports = {
      id: "calender-icon-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite.svg#calender-icon",
      toString: function () {
        return this.url;
      }
    }